//Use CommonJS style via browserify to load other modules
require("./lib/social");
require("./lib/ads");

require("component-responsive-frame/child");